import { Button, Form, Input } from 'antd';
import axios from 'axios';
import React from 'react';

function Register() {
    return (
        <>
            <Form
                name="basic"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                onFinish={(v) => {
                    axios.post('/fuser', v).then(res=>{
                        localStorage.setItem('token', res.data.token);
                    });
                 }}
            >
                <Form.Item
                    label="Ism Sharifingiz"
                    name="fullname"
                    rules={[
                        {
                            required: true,
                            message: "Iltimos To'liq ism sharifingizni kiriting kiriting!",
                        },
                    ]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label="Login"
                    name="login"
                    rules={[
                        {
                            required: true,
                            message: 'Iltimos loginni kiriting!',
                        },
                    ]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="Parol"
                    name="password"
                    rules={[
                        {
                            required: true,
                            message: 'Iltimos parolni kiriting!',
                        },
                    ]}
                >
                    <Input.Password />
                </Form.Item>

                <Form.Item label={null}>
                    <Button block type="primary" htmlType="submit">
                        Kirish
                    </Button>
                </Form.Item>
            </Form>
        </>
    );
}

export default Register;